import { render, staticRenderFns } from "./PublishTake.vue?vue&type=template&id=700bca52&scoped=true&"
import script from "./PublishTake.vue?vue&type=script&lang=js&"
export * from "./PublishTake.vue?vue&type=script&lang=js&"
import style0 from "./PublishTake.vue?vue&type=style&index=0&id=700bca52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700bca52",
  null
  
)

export default component.exports